import { z } from 'zod';

/** Source requirements still needing evidence; never a candidate assessment. */
export const RecruiterVerificationRequirementSchema = z.object({
  source: z.literal('job-description'),
  // Preserve bytes as JavaScript text: offsets use the original input's UTF-16
  // code units. Do not trim, normalize or truncate an evidence excerpt.
  text: z.string().min(1).max(16_000).refine(value => value.trim().length > 0),
  start: z.number().int().min(0).max(15_999),
  end: z.number().int().min(1).max(16_000),
  priority: z.enum(['required', 'preferred']),
  // skill_duration includes an explicitly scoped skill, role or work-domain
  // duration. Its exact source scope stays unverified; it is not total years.
  kind: z.enum(['qualitative_capability', 'education_detail', 'skill_duration']),
  status: z.literal('unverified'),
}).strict().superRefine((requirement, ctx) => {
  if (requirement.end - requirement.start !== requirement.text.length) {
    ctx.addIssue({ code: z.ZodIssueCode.custom, path: ['end'], message: 'The source span must have the exact excerpt length' });
  }
});

export type RecruiterVerificationRequirement = z.infer<typeof RecruiterVerificationRequirementSchema>;

export const RecruiterInterpretationStatusSchema = z.enum(['ready', 'ready_with_verification', 'review_required']);
export const RECRUITER_CLAUSE_OVERFLOW = 'Additional clauses need review. Simplify the requirements and try again.';

/** Retained for old consumers, which still block on unresolvedClauses. */
export const recruiterVerificationDiagnostic = (requirement: RecruiterVerificationRequirement): string =>
  `Review this clause: ${requirement.text.trim().slice(0, 275)}`;
